<!-- ====================================================== -->
<!-- ADMINISTRACIÓN DE GRUPOS -->
<!-- ====================================================== -->

<div class="container-fluid py-3">

  <div class="card groups-card border-0">

    <!-- ================================================== -->
    <!-- HEADER -->
    <!-- ================================================== -->

    <div class="card-header groups-header">

      <div class="d-flex flex-column flex-lg-row justify-content-between align-items-lg-center gap-3">

        <!-- TÍTULO -->

        <div>

          <h4 class="page-title">
            Administración de Grupos
          </h4>

          <p class="page-description">
            Gestiona grupos, subgrupos, usuarios y permisos de acceso.
          </p>

        </div>


        <!-- CREAR GRUPO -->

        <button
          type="button"
          class="btn btn-primary create-group-btn"
          (click)="modalCrearGrupo(contentGrupo, null)">

          <i class="fa-solid fa-plus"></i>

          <span>
            Agregar grupo
          </span>

        </button>

      </div>

    </div>


    <!-- ================================================== -->
    <!-- BODY -->
    <!-- ================================================== -->

    <div class="card-body groups-body">

      <div
        id="batchDelete"
        class="category-table custom-datatable transcation-datatable user-image">


        <!-- ================================================== -->
        <!-- FILTRO DE GRUPOS -->
        <!-- ================================================== -->

        <div class="filter-section">

          <div class="filter-header">

            <div>

              <h6 class="filter-title">
                Buscar grupo
              </h6>

              <p class="filter-description">
                Selecciona un grupo para filtrar la información.
              </p>

            </div>

          </div>


          <div class="filter-control">

            <app-groups
              (idGroup)="onPick($event)">
            </app-groups>

          </div>

        </div>


        <!-- ================================================== -->
        <!-- TABLA -->
        <!-- ================================================== -->

        <div class="groups-table-container">

          <nz-table
            #t
            [nzData]="filtrados"
            nzBordered
            [nzPageSize]="10"
            [nzShowPagination]="true">

            <!-- ============================================== -->
            <!-- HEADER -->
            <!-- ============================================== -->

            <thead>

              <tr>

                <th
                  scope="col"
                  nzWidth="80"
                  class="id-column">

                  ID

                </th>

                <th scope="col">
                  Grupo
                </th>

                <th scope="col">
                  Pertenece A
                </th>

                <th
                  scope="col"
                  class="actions-column">

                  Acciones

                </th>

              </tr>

            </thead>


            <!-- ============================================== -->
            <!-- BODY -->
            <!-- ============================================== -->

            <tbody>

              <!-- OJO: mantener t.data -->

              <tr *ngFor="let g of t.data">

                <!-- ID -->

                <td class="id-cell">

                  <span class="group-id">
                    {{ g.id - g.padre_id }}
                  </span>

                </td>


                <!-- GRUPO -->

                <td>

                  <div class="group-name">

                    <span class="group-icon">
                      <i class="fa-solid fa-layer-group"></i>
                    </span>

                    <span>
                      {{ g.nombre }}
                    </span>

                  </div>

                </td>


                <!-- PADRE -->

                <td>

                  <span class="parent-group">
                    {{ padreNombre(g) }}
                  </span>

                </td>


                <!-- ACCIONES -->

                <td class="actions-column">

                  <div class="group-actions">


                    <!-- EDITAR -->

                    <button
                      type="button"
                      class="btn acciones action-pill--sm"
                      id="edit-group"
                      *ngIf="canManageItem(g)"
                      (click)="modalEditarGrupo(contentGrupo, g)"
                      title="Editar grupo"
                      aria-label="Editar grupo">

                      <i class="fa-solid fa-pen"></i>

                    </button>


                    <!-- AGREGAR SUBGRUPO -->

                    <button
                      type="button"
                      class="btn acciones action-pill--sm"
                      id="add-sub"
                      (click)="modalCrearGrupo(contentGrupo, g)"
                      title="Agregar subgrupo"
                      aria-label="Agregar subgrupo">

                      <i class="fa-solid fa-plus"></i>

                    </button>


                    <!-- ASIGNAR USUARIOS -->

                    <button
                      type="button"
                      class="btn acciones action-pill--sm"
                      id="asig-group"
                      (click)="redericGrupoUser(g.id)"
                      title="Asignar usuarios"
                      aria-label="Asignar usuarios">

                      <i class="fa-solid fa-users"></i>

                    </button>


                    <!-- ELIMINAR -->

                    <button
                      type="button"
                      *ngIf="canManageItem(g)"
                      class="btn acciones action-pill--sm"
                      id="trash-group"
                      (click)="eliminarGrupo(g.id)"
                      title="Eliminar grupo"
                      aria-label="Eliminar grupo">

                      <i class="fa-solid fa-trash-can"></i>

                    </button>


                    <!-- GESTIONAR ACCESO -->

                    <button
                      type="button"
                      *ngIf="!g.publica"
                      class="btn acciones action-pill--sm"
                      id="gestionar-acceso-group"
                      (click)="gestionarAcceso(g.id)"
                      title="Gestionar acceso"
                      aria-label="Gestionar acceso">

                      <i class="fa-solid fa-lock"></i>

                    </button>

                  </div>

                </td>

              </tr>

            </tbody>

          </nz-table>

        </div>

      </div>

    </div>

  </div>

</div>



<!-- ====================================================== -->
<!-- MODAL CREAR / EDITAR GRUPO -->
<!-- ====================================================== -->

<ng-template #contentGrupo let-modal>

  <!-- ==================================================== -->
  <!-- HEADER -->
  <!-- ==================================================== -->

  <div class="modal-header custom-modal-header">

    <div class="modal-heading">

      <div
        class="modal-icon"
        [class.edit-mode]="esEdicion">

        <i
          class="fa-solid"
          [ngClass]="esEdicion ? 'fa-pen' : 'fa-layer-group'">
        </i>

      </div>


      <div>

        <h4 class="modal-title">

          {{
            esEdicion
              ? (groupSelected
                  ? 'Editar grupo ' + groupSelected?.nombre
                  : 'Editar subgrupo')
              : (groupSelected
                  ? 'Crear subgrupo para ' + groupSelected?.nombre
                  : 'Crear grupo')
          }}

        </h4>


        <p class="modal-description">

          {{
            esEdicion
              ? 'Actualiza la información del grupo seleccionado.'
              : (groupSelected
                  ? 'Agrega un nuevo subgrupo dentro del grupo seleccionado.'
                  : 'Crea un nuevo grupo dentro del sistema.')
          }}

        </p>

      </div>

    </div>


    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')">
    </button>

  </div>


  <!-- ==================================================== -->
  <!-- BODY -->
  <!-- ==================================================== -->

  <div class="modal-body custom-modal-body">

    <form [formGroup]="formGrupo">


      <!-- ================================================== -->
      <!-- NOMBRE -->
      <!-- ================================================== -->

      <div class="field-group">

        <label class="form-label">

          Nombre de

          {{
            esEdicion
              ? (groupSelected ? 'grupo' : 'grupo')
              : (groupSelected ? 'subgrupo' : 'grupo')
          }}

          <span class="required-mark">*</span>

        </label>


        <div class="input-icon-wrapper">

          <i class="fa-solid fa-layer-group"></i>

          <input
            type="text"
            class="form-control"
            formControlName="nombre"
            placeholder="Ingrese el nombre" />

        </div>


        <app-error-message
          [control]="formGrupo.get('nombre')"
          errorKey="required"
          message="El nombre de {{ esEdicion ? (groupSelected ? 'grupo' : 'grupo') : (groupSelected ? 'subgrupo' : 'grupo') }} obligatorio">
        </app-error-message>

      </div>



      <!-- ================================================== -->
      <!-- TIPO DE GRUPO -->
      <!-- ================================================== -->

      <div
        class="field-group"
        *ngIf="formGrupo.get('padreId')?.value === null">

        <label class="form-label">

          Tipo de grupo

          <span class="required-mark">*</span>

        </label>


        <div class="select-icon-wrapper">

          <i class="fa-solid fa-users"></i>

          <select
            class="form-select"
            formControlName="tipoGrupo">

            <option value="">
              Seleccione una opción
            </option>

            <option value="INT">
              Interno
            </option>

            <option value="EXT">
              Externo
            </option>

          </select>

        </div>


        <app-error-message
          [control]="formGrupo.get('tipoGrupo')"
          errorKey="required"
          message="El tipo de grupo es obligatorio">
        </app-error-message>

      </div>



      <!-- ================================================== -->
      <!-- PÚBLICO -->
      <!-- ================================================== -->

      <div
        class="public-option"
        *ngIf="accesUser">

        <div class="public-option-content">

          <div class="public-option-icon">

            <i class="fa-solid fa-earth-americas"></i>

          </div>


          <div class="public-option-info">

            <label
              class="public-option-title"
              for="publica">

              Hacer público este

              {{
                esEdicion
                  ? (groupSelected ? 'grupo' : 'subgrupo')
                  : (groupSelected ? 'subgrupo' : 'grupo')
              }}

            </label>


            <span class="public-option-description">

              Al activar esta opción el

              {{
                esEdicion
                  ? (groupSelected ? 'grupo' : 'subgrupo')
                  : (groupSelected ? 'subgrupo' : 'grupo')
              }}

              podrá ser utilizado por otros usuarios.

            </span>

          </div>

        </div>


        <!-- SWITCH -->

        <label class="modern-switch">

          <input
            type="checkbox"
            id="publica"
            formControlName="publica">

          <span class="slider"></span>

        </label>

      </div>

    </form>

  </div>


  <!-- ==================================================== -->
  <!-- FOOTER -->
  <!-- ==================================================== -->

  <div class="modal-footer custom-modal-footer">

    <button
      type="button"
      class="btn btn-light secondary-button"
      (click)="modal.close('Cerrar click')">

      Cerrar

    </button>


    <button
      type="button"
      class="btn btn-primary primary-button"
      [disabled]="formGrupo.invalid"
      (click)="generarAccion()">

      <i class="fa-solid fa-floppy-disk me-2"></i>

      Guardar

    </button>

  </div>

</ng-template>